import { ProCard } from '@ant-design/pro-components'
import { Form, Input } from 'antd'

export function LegalRepresentativeFields() {
  return (
    <section className="scroll-mt-24" id="section-representative">
      <ProCard headerBordered title="法人信息" variant="outlined">
        <p className="text-content-muted mt-0 mb-4 text-sm">选填，可手动填写或通过上方身份证原件识别填入。</p>
        <div className="grid gap-x-5 md:grid-cols-2">
          <Form.Item label="法人姓名" name="legalRepresentative" rules={[{ max: 80 }]}>
            <Input maxLength={80} placeholder="选填，请输入法人姓名" />
          </Form.Item>
          <Form.Item
            label="法人身份证号"
            name="legalRepresentativeIdNumber"
            normalize={(value: string) => value.trim().toUpperCase()}
            rules={[{ pattern: /^(?:\d{15}|\d{17}[\dX])?$/, message: '身份证号应为 15 位数字或 18 位数字及 X' }]}
          >
            <Input maxLength={18} placeholder="选填，请输入法人身份证号" />
          </Form.Item>
        </div>
      </ProCard>
    </section>
  )
}
